import React, {useContext, useRef, useEffect, useState} from "react";

import { ProductCustomizerVariantContext } from "@contexts/ProductCustomizerVariant.jsx"
import { Engine } from "json-rules-engine"
import AjaxPage from "@components/general/AjaxPage.jsx"
import ProductCustomizerNoteFooter from "./ProductCustomizerNoteFooter.jsx"

export default ({children}) => {

  const [dismissed, setDismissed] = useState(false);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const rulesEngine = useRef(new Engine());
  const { variant, cartPopups } = useContext(ProductCustomizerVariantContext);

  useEffect(() => {
    if (!cartPopups.length) return;

    const popups = cartPopups
      .filter((p) => p.active?.value === "true" && p.page?.reference !== null)
      .map((p) => ({
        page: p.page?.reference?.handle,
        rules: JSON.parse(p.rules?.value ?? '{}'),
        priority: Number(p.priority?.value) || 0,
      }));

    popups.forEach((popup) => {
      try {
        rulesEngine.current.addRule({
          conditions: {
            ...popup.rules
          },
          event: {
            type: 'popup',
            params: {
              page: popup.page,
              priority: popup.priority
            }
          }
        });
      } catch(e) {
        console.warn("cartPopups", cartPopups);
        console.error(`Issue with cart popup: ${popup.page}`);
        console.error(e);
      }
    });

    if (!variant) return;

    setLoading(true);
    setDismissed(false);

    const vehicle = VehicleData.getSelectedVehicle();

    let facts = {
        ...vehicle,
        option1: variant?.options[0]?.value,
        option2: variant?.options[1]?.value,
        option3: variant?.options[2]?.value,
        sku: variant?.sku,
        qty: 1, // default to 1 in customizer
        available: variant?.available,
      }

    if (location.search.includes("debug")) {
      console.log("======== DEBUGGING CART POPUP RULES ========");
      console.log("Facts:", facts);
      console.log("Popups:", popups);
    }

    rulesEngine.current
      .run(facts)
      .then(({ events }) => {
        events = events.sort((a, b) => a.params.priority - b.params.priority);
        setEvents(events);
        setLoading(false);
      });

  }, [cartPopups, variant, rulesEngine]);

  const noteEvent = events.find(({type}) => type == "popup");

  return <>
            { loading ?
                <pill-loader class="pill-loader" aria-busy={loading}></pill-loader>
              :
                ( noteEvent && !dismissed ?
                      <>
                        <AjaxPage handle={noteEvent.params?.page} />
                        <ProductCustomizerNoteFooter onClick={() => setDismissed(true)} />
                      </>
                    :
                      children
                )
            }
         </>;
}
